export default __webpack_public_path__ + "static/media/estrellaSolid.4e3480c6.svg";